<div id="countdown">
  <p id="days">{{days}}</p>
  <p id="hours">{{hours}}</p>
  <p id="minutes">{{minutes}}</p>
  <p id="seconds">{{seconds}}</p>
</div>